var render = function render(){var _vm=this,_c=_vm._self._c;return _c('lightning-template',{attrs:{"wishes-lightening":_vm.wishesLightening,"field-errors":_vm.fieldErrors},on:{"field-change":_vm.onFieldChange}})
}
var staticRenderFns = []

export { render, staticRenderFns }